import { DEFAULT_TEMPLATES_URL } from '../constants';

export const getTemplates = async <T>(): Promise<T[]> => {
  const response = await fetch(DEFAULT_TEMPLATES_URL);
  const data: T[] = await response.json();
  return data;
};
